(() => {
  const initialize = (root = document) => {
    root.querySelectorAll('[data-ksl-fixed]').forEach((panel) => {
      if (panel.dataset.initialized) return;
      panel.dataset.initialized = 'true';
      const form = document.getElementById(panel.dataset.formId);
      if (form) form.enctype = 'multipart/form-data';
      panel.querySelectorAll('[data-artwork]').forEach((input) => {
        let previewUrl;
        input.addEventListener('change', () => {
          const file = input.files[0];
          const preview = input.parentElement.querySelector('[data-artwork-preview]');
          const status = input.parentElement.querySelector('[data-artwork-status]');
          if (previewUrl) URL.revokeObjectURL(previewUrl);
          preview.hidden = true;
          preview.removeAttribute('src');
          status.textContent = '';
          if (!file) return;
          if (!['image/jpeg', 'image/png', 'image/webp'].includes(file.type) || file.size > 10 * 1024 * 1024) {
            status.textContent = panel.dataset.fileError || 'Choose a JPG, PNG or WebP image up to 10 MB.';
            input.value = '';
            return;
          }
          previewUrl = URL.createObjectURL(file);
          preview.src = previewUrl;
          preview.hidden = false;
          status.textContent = file.name;
        });
      });
    });
  };
  initialize();
  if (!window.kslFixedObserver) {
    window.kslFixedObserver = new MutationObserver(() => initialize());
    window.kslFixedObserver.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
